import { render, staticRenderFns } from "./TeamSwitcher.vue?vue&type=template&id=42388993&"
import script from "./TeamSwitcher.vue?vue&type=script&lang=js&"
export * from "./TeamSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./TeamSwitcher.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TeamSwitcher.vue"
export default component.exports